import i18n from '../../i18n/i18n'

export const mapMonthToAbbr = (month: number) => {
  switch (month) {
    case 0:
      return i18n.t('OUT_4937_january_abbreviation')
    case 1:
      return i18n.t('OUT_4937_february_abbreviation')
    case 2:
      return i18n.t('OUT_4937_march_abbreviation')
    case 3:
      return i18n.t('OUT_4937_april_abbreviation')
    case 4:
      return i18n.t('OUT_4937_may_abbreviation')
    case 5:
      return i18n.t('OUT_4937_june_abbreviation')
    case 6:
      return i18n.t('OUT_4937_july_abbreviation')
    case 7:
      return i18n.t('OUT_4937_august_abbreviation')
    case 8:
      return i18n.t('OUT_4937_september_abbreviation')
    case 9:
      return i18n.t('OUT_4937_october_abbreviation')
    case 10:
      return i18n.t('OUT_4937_november_abbreviation')
    case 11:
      return i18n.t('OUT_4937_december_abbreviation')
    default:
      return ''
  }
}

export default function(date: Date, year = false, day = true, month = true) {
  return `${day ? date.getDate() + ' ' : ''}${
    month ? mapMonthToAbbr(date.getMonth()) + ' ' : ' '
  }${year ? date.getFullYear() : ''}`
}
